import React, { useEffect, useRef, useState } from 'react'
import Logo from '../../components/ui/Logo';
import { collection, deleteDoc, doc, getDocs, query, where } from 'firebase/firestore';
import { db } from '../../firebase';
import { Button, Card, Col, Container, Row, Stack } from 'react-bootstrap';
import Footer from '../../components/ui/Footer';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Header from '../../components/ui/Header';

export default function ServiceManagement() {

   const [services, setServices] = useState([]);
   const [user, setUser] = useState({});
   const servicesCollectionName = 'Services';
   const userCollectionName = 'Users';
   const { currentUser } = useAuth();
   

//    useEffect(() => {
//     if (!vantaEffect) {  
//     setVantaEffect(EFFECT({
//         THREE: THREE,
//         el: myRef.current,
//         mouseControls: true,
//         touchControls: true,
//         gyroControls: false,
//         skyColor: '#524843',
//         cloudColor: '#e03d4d',
//         }));
//     }
//     return () => {
//     if (vantaEffect) vantaEffect.destroy()
//     }
// }, [])

    useEffect(() => {
        const getServices = async () => {
            // Get services from Firestore DB 
            const data = await getDocs(collection(db, servicesCollectionName));
            setServices(data.docs.map((doc) => ({ ...doc.data(), id: doc.id})));
        }

        const getUser = async () => {
            const queryUser = query(collection(db, userCollectionName), where("identity_id", "==", currentUser.uid))
            const querySnapshot = await getDocs(queryUser);

            querySnapshot.forEach((doc) => {
                setUser({id: doc.id, 
                    ...doc.data()
                })
            })
        }

        getServices();

        if(currentUser){
            getUser()
        }
           
        
        console.log(services, user)
    }, []);

    const heading = user.role_name === 'Admin' ? 'Service Management' : 'Services Offered';

    const handleDeleteService = async (service) => {
        if(window.confirm('Are you sure your want to delete ' + service.display_name + ' service?')){
            await deleteDoc(doc(db, servicesCollectionName, service.id));
            window.location.reload();
        }
    }
    
  return (
    <div className='txt-green'>
       <Header>
            <h2 className='text-center text-dark thick-font sub-header-txt-shadow'>{heading}</h2>
        </Header>

        

        <Container className='my-4'>
            <Row className='justify-content-center'>
                {user.role_name === 'Admin' ? <Link to={"/service-management/create-service"} type="button" className={'btn text-white btn-secondary w-25 mb-3'}>Add New Service</Link> : <></>}
            </Row>
            <Row>
                {services && services.map(service => {
                    return (
                        <Col key={service.id} xs={12} md={6}>
                            <Card className='bg-dark text-white mb-2'>
                                <Card.Header>
                                <Card.Title>{service.display_name}</Card.Title>
                                {user.role_name === 'Admin' ? 
                                    <Card.Subtitle>
                                        <Stack direction='horizontal' gap={3} >
                                            <Link to={"/service-management/create-service/" + service.id} type="button" className={'btn btn-warning mb-3'}>Edit Service</Link>
                                            <Button onClick={() => handleDeleteService(service)} type="button" className={'btn btn-danger mb-3'}>Delete Service</Button>
                                        </Stack>
                                    </Card.Subtitle>
                                : <></>}
                                </Card.Header>
                                <Card.Body>
                                    <Card.Text><b>{service.description}</b></Card.Text>
                                    <Card.Text>${service.price}.00</Card.Text>
                                    <Card.Text>{service.duration} {service.duration > 1 ? "hours" : "hour"}</Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>)
                })}
            </Row>
        </Container>
        <Footer></Footer>
    </div>
  )
}
